
// Mahéquline mega menu — keep dropdown anchored just below the actual header height
(function() {
  function updateMegaMenuTop() {
    var hdr = document.querySelector('.site-header');
    if (!hdr) return;
    var rect = hdr.getBoundingClientRect();
    document.documentElement.style.setProperty('--mega-menu-top', rect.bottom + 'px');
  }
  document.addEventListener('DOMContentLoaded', updateMegaMenuTop);
  window.addEventListener('resize', updateMegaMenuTop);
  window.addEventListener('scroll', updateMegaMenuTop, { passive: true });
  document.addEventListener('toggle', function(e) {
    if (e.target && e.target.classList && e.target.classList.contains('site-nav__details')) {
      updateMegaMenuTop();
    }
  }, true);
})();

// Mahéquline mega menu — explicit hover handling with a grace period.
//
// Why JS instead of pure CSS :hover: the trigger summary doesn't fill the
// header's vertical content area, so when the cursor moves down from the
// summary text into the dropdown panel, it briefly crosses a "dead zone"
// (header padding, gap, etc.) where nothing is being hovered. CSS :hover
// drops immediately, the dropdown closes, and you can never reach the panel
// content. A pure-CSS bridge worked but caused side effects on other pages.
//
// Approach: open the dropdown via the [open] attribute on <details> on
// mouseenter, schedule a close 150ms after mouseleave, and cancel the close
// if the cursor re-enters either the trigger LI or the dropdown panel within
// that window. The existing rule `details[open] > .site-nav__dropdown`
// (theme.css) keeps the panel visible whenever [open] is set, regardless of
// :hover state.
(function() {
  if (window.__mahequlineMegaMenuHoverInit) return;
  window.__mahequlineMegaMenuHoverInit = true;

  var HOVER_GRACE_MS = 150;

  function bind(item) {
    if (item.__megaMenuHoverBound) return;
    item.__megaMenuHoverBound = true;

    var details = item.querySelector('details.site-nav__details');
    if (!details) return;
    var dropdown = details.querySelector('.site-nav__dropdown');
    var summary = details.querySelector('summary');

    // Click-to-navigate: theme.js's hoverMenu() normally adds this, but we
    // skip mega-menu items there to neutralize its grace-less mouseleave.
    // Restore the click→navigate behavior here so clicking the trigger goes
    // to the parent collection page (e.g. NEW → /collections/new).
    if (summary && summary.dataset && summary.dataset.link) {
      var link = summary.dataset.link;
      summary.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = link;
      });
    }

    var closeTimer = null;

    function open() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      // Close any other open mega-menu so two panels never overlap
      document.querySelectorAll('details.site-nav__details[open]').forEach(function(d) {
        if (d !== details && d.closest('.site-nav--is-megamenu')) {
          d.removeAttribute('open');
        }
      });
      if (!details.hasAttribute('open')) details.setAttribute('open', '');
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function() {
        details.removeAttribute('open');
        closeTimer = null;
      }, HOVER_GRACE_MS);
    }

    // The trigger LI's bounding box covers the summary only — the dropdown
    // is position:fixed and out of layout flow, so it doesn't trigger
    // mouseenter on the LI. Bind enter/leave on both the LI and the
    // dropdown panel so either keeps the menu alive.
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
    if (dropdown) {
      dropdown.addEventListener('mouseenter', open);
      dropdown.addEventListener('mouseleave', scheduleClose);
    }
  }

  function init() {
    document.querySelectorAll('.site-nav--is-megamenu.site-nav__item').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
